import { Volume } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/volume';
import { Proportion } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/proportion';
import { Rate } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/rate';
import { Financial } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/financial';
import { Retention } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/retention';
import { AcademicQuality } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/academic-quality';
import { categories } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/categories';
import { criticalElementsExtensions } from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-configuration';
import type { CriticalElementsExtensions } from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-configuration';
import type {
  Category,
  GoalSchema,
} from 'containers/admin/clients/client/tabs-components/goals-tab/types';

const baseSchema: GoalSchema = {
  ...Volume,
  ...Proportion,
  ...Rate,
  ...Financial,
  ...Retention,
  ...AcademicQuality,
};

const extendCategories = (
  originalCategories: Category[],
  extensions: CriticalElementsExtensions
): Category[] =>
  originalCategories.map((category) => {
    const categoryExtension = extensions[category.name];

    if (categoryExtension && category.details && category.details.options) {
      return {
        ...category,
        details: {
          ...category.details,
          options: [...category.details.options, ...categoryExtension.options],
        },
      };
    }

    return category;
  });

export const criticalElementsCategories: Category[] = extendCategories(
  categories,
  criticalElementsExtensions
);

export const schema: GoalSchema = baseSchema;
